import Card from './card.view';

export default Card;
